module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7223cc265f7989f555578860af82cf6e.png";